import FrameOneModal from "@/components/modals/modalComponents/FrameOneModal";
import FrameModalBody from "@/components/modals/modalComponents/FrameModalBody";
import {IoCloseSharp} from "react-icons/io5";
import {AiOutlineExclamationCircle} from "react-icons/ai";
import FrameButton from "@/components/buttons/FrameButton";

interface Props {
    isOpen: boolean;
    toggle: () => void;
    onConfirm: () => void;
}

export default function LoadDpayConfirmModal(props: Props) {
    function onPaymentConfirm() {
        props.toggle();
        props.onConfirm();
    }

    return (
        <FrameOneModal
            isOpen={props.isOpen}
            toggle={props.toggle}
            contentClassName="govip-nft-redeem-confirm-modal"
        >
            <FrameModalBody className="govip-nft-redeem-confirm-modal_body">
                <div className="govip-nft-redeem-confirm-modal_body_close-wrapper">
                    <IoCloseSharp onClick={props.toggle}/>
                </div>

                <div className="govip-nft-redeem-confirm-modal_body_content">
                    <AiOutlineExclamationCircle />
                    <div className="govip-nft-redeem-confirm-modal_body_content_header">
                        Load {import.meta.env.VITE_TOKEN_NAME} Now?
                    </div>
                    <div className="govip-nft-redeem-confirm-modal_body_content_message">
                        The purchase of {import.meta.env.VITE_TOKEN_NAME} is final.<br/>
                        {import.meta.env.VITE_TOKEN_NAME} is non-refundable and non-returnable.
                    </div>
                </div>

                <FrameButton
                    color="purple"
                    size="narrow"
                    className="govip-nft-redeem-confirm-modal_body_button"
                    onClick={onPaymentConfirm}
                >
                    Confirm
                </FrameButton>


            </FrameModalBody>
        </FrameOneModal>
    );
}